import {Component, Input} from '@angular/core';
import {HelperPipesModule} from '@aztrix/helpers';
import {IconsModule} from '@aztrix/icons';
import {Agreement, AgreementVerificationType} from '@aztrix/models';
import {AgreementRepresentation, ProposalRepresentation} from '@aztrix/sdk';
import {TranslatePipe} from '@aztrix/translate';

@Component({
  selector: 'ax-agreement-verification-status',
  templateUrl: './agreement-verification-status.component.html',
  styleUrls: ['./agreement-verification-status.component.scss', '../property.scss'],
  standalone: true,
  imports: [IconsModule, TranslatePipe, HelperPipesModule],
})
export class AgreementVerificationStatusComponent {
  @Input() agreement: Agreement | AgreementRepresentation;
  @Input() verification?: AgreementVerificationType | ProposalRepresentation.VerificationEnum;
  @Input() isExternal = false;
}
